import React from "react";
import HeroSection from "../components/home/HeroSection";
import VisionSection from "../components/home/VisionSection";
import ApplicationsSection from "../components/home/ApplicationsSection";
import ProductPortfolioSection from "../components/home/ProductPortfolioSection";
import NewsFeatureSection from "../components/home/NewsFeatureSection";
import FootprintTeaserSection from "../components/home/FootprintTeaserSection";
import AwardsStrip from "../components/home/AwardsStrip";
import ContactCTA from "../components/home/ContactCTA";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <VisionSection />
      <ApplicationsSection />
      <ProductPortfolioSection />
      <NewsFeatureSection />
      <FootprintTeaserSection />
      <AwardsStrip />
      <ContactCTA />
    </div>
  );
};

export default Home;
